import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router';
import "./VoucherMenuDefaultOrderPage.scss"
import sucessIc from "../../assets/success.svg"
import { LOCAL_STORAGE_ITEMS_NAMES } from '../../../RestaurantWidget/utilities/helper/helper';

const VoucherOrderSuccessPage = () => {
    useEffect(() => {
        localStorage.removeItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_TRACK_ORDER)
    }, [])
    const params = useParams();
    const history = useHistory();

    const onClickBackToMenu = () => history.push("/vouchers");

    return (
        <div className='Order-success-form-deafult'>
            <img alt='' src={sucessIc} className='sucessIc' />
            <div className="main-message-text">Your order has been accepted.</div>
            <div lassName="sub-message-text-cont">Your Order ID is : {params.id}</div>
            <div type="text" className="card-payment-desc-text">
                Your voucher purchase is confirmed!<br />
                Thank you for your purchase. Your voucher is now ready to be redeemed.</div>
            <div className='btn-conatiner'>
                <div onClick={onClickBackToMenu} className='menu-btn'>Back to Vouchers</div>
            </div>

        </div>
    )
}

export default VoucherOrderSuccessPage